export default __webpack_public_path__ + "static/media/NTTS-r.a275991c.png";